/* ============
 * Mutations for the requirements module
 * ============
 *
 * The mutations that are available on the
 * requirements module.
 */

export default {
  setJWT (state, payload) {
    state.jwt = payload
  },
  setExp (state, payload) {
    state.exp = payload
  },
  setRequirements (state, payload) {
    state.setRequirements = payload
  },
  clear (state) {
    state.maxAmount = null
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/requirements/mutations.js